export default __webpack_public_path__ + "static/media/distractions5.25847fa1.png";